(() => {
  const widgets = Array.from(document.querySelectorAll('.trustpilot-widget'));
  if (widgets.length === 0) return;

  const pendingWidgets = new Set();
  let bootstrapLoading = false;

  function hydrateWidget(widget) {
    if (!window.Trustpilot?.loadFromElement) return;
    if (widget.querySelector('iframe')) {
      pendingWidgets.delete(widget);
      return;
    }

    window.Trustpilot.loadFromElement(widget, true);
    pendingWidgets.delete(widget);
  }

  function hydrateVisibleWidgets() {
    pendingWidgets.forEach(hydrateWidget);
  }

  function loadTrustpilotBootstrap() {
    if (window.Trustpilot?.loadFromElement) {
      hydrateVisibleWidgets();
      return;
    }
    if (bootstrapLoading) return;
    bootstrapLoading = true;

    const existingScript = document.querySelector(
      'script[data-trustpilot-bootstrap], script[src*="widget.trustpilot.com/bootstrap"]',
    );
    if (existingScript) {
      existingScript.addEventListener('load', () => requestAnimationFrame(hydrateVisibleWidgets), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    script.dataset.trustpilotBootstrap = 'true';
    script.addEventListener('load', () => requestAnimationFrame(hydrateVisibleWidgets), { once: true });
    document.head.appendChild(script);
  }

  if (!('IntersectionObserver' in window)) {
    widgets.forEach((widget) => pendingWidgets.add(widget));
    loadTrustpilotBootstrap();
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      observer.unobserve(entry.target);
      pendingWidgets.add(entry.target);
      loadTrustpilotBootstrap();
    });
  }, { rootMargin: '0px 0px 100px' });

  widgets.forEach((widget) => observer.observe(widget));
})();
